"use strict";
import React from "react";
var FormInput = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "FormInput", className: this.divClasses() }, this.label(), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: this.inputType(),
        placeholder: this.props.placeholder,
        onChange: this.props.onChange,
        onKeyDown: this.props.onKeyDown,
        ref: this.props.refs,
        value: this.props.value,
        checked: this.props.checked,
        id: this.props.id
      }
    ), this.errorMessage());
  },
  inputType: function() {
    return this.props.type || "text";
  },
  label: function() {
    if (this.props.label) {
      return /* @__PURE__ */ React.createElement("label", { htmlFor: this.props.id }, this.props.label);
    }
  },
  divClasses: function() {
    var classes = this.props.divClasses;
    if (this.props.errors) {
      classes += " error";
    }
    return classes;
  },
  errorMessage: function() {
    var errorMessage;
    if (errorMessage = this.props.errors) {
      return /* @__PURE__ */ React.createElement("small", { className: "error" }, errorMessage);
    }
  }
});
export default FormInput;
